var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",style:({'--c-main': _vm.colour, '--c-bg': _vm.bg})})}
var staticRenderFns = []

export { render, staticRenderFns }